<template>
    <form
        :action="result.form.action"
        method="POST"
        accept-charset="utf-8"
        class="def-liq-pay-button"
    >
        <input
            v-for="input in result.form.inputs"
            :type="input.type"
            :name="input.name"
            :value="input.value"
            :src="input.src"
        >
    </form>
</template>

<script>
export default {
    name: 'DefLiqPayButton',
    props: ['result'],
}
</script>

<style lang="scss" scoped>
.def-liq-pay-button{

}
</style>